import script from "./CollectedObjects.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectedObjects.vue?vue&type=script&setup=true&lang=ts"

import "./CollectedObjects.vue?vue&type=style&index=0&id=233edd81&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-233edd81"]])

export default __exports__